<template>
  <section class="bg-sand overflow-hidden">
    <div class="section-container lg:py-8">
      <h2 class="heading text-green-darkest max-lg:pb-4">
        {{ $t('Agenda') }}
      </h2>
      <EventCalendar :events="events" />
    </div>
  </section>
</template>

<script setup lang="ts">
import {useEvents} from '~/composables/useEvents';

const {events} = useEvents();
</script>
